import React, { useEffect, useState, useCallback } from "react";
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import GoogleMapReact from "google-map-react";
import { useDispatch } from "react-redux";
import { postAnthoreTask } from "../../../Redux/Actions/ActionTask";
import { useSelectorCustom } from "../../General/GeneralComponent/useSelectorCustom";
import { FunctionsLoading } from "../../Main/Statistics/FunctionsLoading";
import { VariableAnthoreTask } from "./VariableAnthoreTask";
import { loadReportType } from "../../../Redux/Actions/ActionReportType";
import { base_url } from "../../General/Notification";
import axios from "axios"
// Marker Component
const Marker = () => (
  <div
    style={{
      color: "red",
      fontSize: "24px",
      transform: "translate(-50%, -50%)",
    }}
  >
    📍
  </div>
);

function AddAnthoreTask({ medical_rep_id, date, id, t, langmiamed, open, setOpen }) {
  const dispatch = useDispatch();
  const { TGbymedicalRep, loadingTG } = useSelectorCustom();
  const { LoadTargetByMedicalRepCustom } = FunctionsLoading();
  const { setState, state, handleChangeTask, setLoad } = VariableAnthoreTask();

  const [latLng, setLatLng] = useState({
    lat: state.lat || 33.51708042389797,
    lng: state.lng || 36.2843398898508,
  });
  const [reportTypes, setReportTypes] = useState([]); // Store report types

  // Load report types when the component mounts
  useEffect(() => {
    let token = localStorage.getItem("tokenMiamed");
        let langmiamed = localStorage.getItem('langmiamed');
        axios.get(`${base_url}api/report-types`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                "lang": langmiamed
            }
        }).then((res) => {
          setReportTypes(res?.data?.data)
            // dispatch(getReportType(res.data.data))
        }).catch((err) => {
        })
  }, []);

  // Memoized map click handler
  const handleMapClick = useCallback(({ lat, lng }) => {
    setLatLng({ lat, lng });
  }, []);

  const submit = (e) => {
    e.preventDefault();
    dispatch(
      postAnthoreTask(
        state.description,
        state.address,
        latLng.lat,
        latLng.lng,
        // state.city_id,
        // state.target_group_id,
        state.report_type_id,
        medical_rep_id,
        state.time,
        date,
        state.status,
        // state.priority_level,
        id,
        setLoad,
        setOpen,
        setState,
        state
      )
    );
  };

  return (
    <RModal
      open={open}
      onClose={() => setOpen(false)}
      center
      classNames={{
        modal: "modal-lg",
      }}
      focusTrapped={false}
    >
      <div
        className={`container div_addPop ${langmiamed === "ar" ? "text-end" : "text-start"}`}
        dir={langmiamed === "ar" ? "rtl" : "ltr"}
      >
        <h3>{t("external_visites")}</h3>
        <form onSubmit={submit} className="row g-3">
          {/* Address */}
          <div className="col-md-6">
            <label className="form-label">{t("address")}</label>
            <input
              type="text"
              value={state.address}
              onChange={(e) => handleChangeTask(e.target.value, "address")}
              className="form-control"
            />
          </div>

          {/* Time */}
          <div className="col-md-6">
            <label className="form-label">{t("time")}</label>
            <input
              type="time"
              value={state.time}
              onChange={(e) => handleChangeTask(e.target.value, "time")}
              className="form-control"
            />
          </div>

          <div className={langmiamed == "ar" ? "textRight" : ""}>
          <span>{t("Report type")}: </span>
        </div>
        <select
          value={
            state.report_type_id === "" ? t("report_type_id") : state.report_type_id
          }
          onChange={(e) => handleChangeTask(e.target.value, "report_type_id")}
        >
          <option disabled="disabled" selected="selected">
            {t("Report type")}
          </option>
          {reportTypes?.map((i)=>{
            return(
              <>
              <option value={i.id}>{t(i.name)}</option>
              
              </>
            )
          })}
      
        </select>

          {/* Google Map */}
          <div className="col-12">
            <label className="form-label">{t("Select Location")}</label>
            <div style={{ height: "300px", width: "100%" }}>
              <GoogleMapReact
                bootstrapURLKeys={{ key: "AIzaSyAkCSalRaX8rEi2m2I0E0lhOq94vK3pFzE" }} // Replace with your key
                center={latLng}
                zoom={10}
                onClick={handleMapClick}
              >
                <Marker lat={latLng.lat} lng={latLng.lng} />
              </GoogleMapReact>
            </div>
        
          </div>

          {/* Note */}
          <div className="col-12">
            <label className="form-label">{t("description")}</label>
            <textarea
              value={state.description || ""}
              onChange={(e) => handleChangeTask(e.target.value, "description")}
              className="form-control"
              rows="3"
            ></textarea>
          </div>

          {/* Submit Button */}
          <div className="col-12">
            <button
              type="submit"
              className={`btn btn-primary w-100 ${state.Load ? "disabled" : ""}`}
              disabled={state.Load}
            >
              {state.Load ? t("Loading ...") : t("Save")}
            </button>
          </div>
        </form>
      </div>
    </RModal>
  );
}

export default AddAnthoreTask;
